<template>
  <div class="xs-12">
    <div class="dea-ico-copia-digitale"></div>
    <h2 class="dea-evaluation-modal__title dea-heading--medium__l" data-test="activation-modal-title">
      Attiva la tua copia
    </h2>
    <div class="dea-heading--regular__ms">
      Attiva la tua copia.
      <br />
      Abbiamo bisogno di qualche informazione prima di iniziare:
    </div>
    <div class="dea-heading--medium__ms dea-evaluation-modal__evaluation">Quale libro vuoi attivare?</div>
  </div>
</template>

<script>
export default {
  name: "ActivationModalContent",
};
</script>
